import { CitySetupPage } from '@/features/auth'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/(auth)/continue-registration')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CitySetupPage />
}
